import Vue from 'vue'
import App from './App.vue'
import router from './router'
import http from '@/utils/request'
import MDialog from 'vue-m-dialog'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'vue-m-dialog/dist/index.css'
import 'swiper/swiper-bundle.css'
Vue.use(ElementUI);

/* eslint-disable */
import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay } from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
SwiperClass.use([Pagination, Mousewheel, Autoplay])
Vue.use(getAwesomeSwiper(SwiperClass))
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)
import 'swiper/swiper-bundle.css'
/* eslint-enable */

Vue.config.productionTip = false

Vue.use(MDialog) // 将挂载 m-dialog组件和 Vue.prototype.$alert 和 Vue.prototype.$confirm
// Vue.use(VueAwesomeSwiper)

Vue.prototype.$http = http

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
